// Api
// @min, @max: int
// required
const randomGenerator = (min = 0, max = 999) =>
  Math.floor(Math.random() * (max - min)) + min;

  /**
   * 
   * @param {Number} value 
   * @param {Number} place 
   * @returns value rounded up to the precision of the specified decimal place
   */
const roundToDecimalPlace = (value, place) => {
  const factor = 10 ** place;
  return Math.round(value * factor) / factor;
};

/**
 * 
 * @param {Number} value 
 * @param {Number} place 
 * @returns value rounded down to the precision of the specified decimal place
 */
const roundToDecimalPlaceDown = (value, place) => {
  const factor = 10 ** place;
  return Math.floor(value * factor) / factor;
}


/**
 *
 * @param {Number} value
 * @return value formatted to USD String
 */
const formatCurrency = (value) => {
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
  });

  if (isNaN(Number(value))) {
    return formatter.format(0);
  }
  return formatter.format(value);
}

export const numbers = {
  randomGenerator,
  roundToDecimalPlace,
  roundToDecimalPlaceDown,
  formatCurrency,
};
